export default __webpack_public_path__ + "static/media/cnnouns-proposal-flow.5d7e7032.jpg";